import { StartBaseMusic, StartBaseMusicSoft } from "commands/music";
import gameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import LoopWins from "slotworks/state-machine/standard/states/loop-wins";

export default class ICLoopWins extends LoopWins {

    public onEnter() {
        if (gameState.currentGameHasSymbolWinResults()) {
            const record = gameState.getCurrentGame().getCurrentRecord() as SpinRecord;

            if(record.timesCycled === 0) {
                StartBaseMusicSoft();
            }
        }
        super.onEnter();
    }

    public onExit() {
        StartBaseMusic();
        super.onExit();
    }
}